import { combine } from "@reactables/core";
import PaymentService from "Helpers/PaymentService";
import UserEntryDataService from "Helpers/UserEntryDataService";
import PortalOneModalService from "Helpers/PortalOneModalService";
import { RxPayment } from "./RxPayment";

export const RxCoverageApplication = ({
  paymentService,
  userEntryDataService,
  portalOneModalService,
}: {
  paymentService: PaymentService;
  userEntryDataService: UserEntryDataService;
  portalOneModalService: PortalOneModalService;
}) => {
  const rxPayment = RxPayment({
    paymentService,
    userEntryDataService,
    portalOneModalService,
  });
  return combine({
    payment: rxPayment,
  });
};
